import { CSSObject, Theme } from '@core-ui/react-stitch';
import getTextStyles from '../getTextStyles';
import getControlBeforeStyles from '../getControlBeforeStyles';

const getControlStyles =
  (isBRRedesignEnabled: boolean) =>
  (base: CSSObject, { theme }: { theme: Theme }): CSSObject => ({
    ...base,
    ...getTextStyles(isBRRedesignEnabled),
    color: theme.color.b1,
    marginTop: 0,
    position: 'relative',
    width: '100%',
    textAlign: 'center',
    '&::before': {
      ...getControlBeforeStyles(theme, isBRRedesignEnabled),
      width: '0.5rem',
      right: '-0.5rem',
      backgroundSize: '100% auto',
      backgroundPositionX: 'right',
      marginLeft: '0.5rem',
      marginRight: '0.5rem',
    },
    ...(isBRRedesignEnabled
      ? {
          textAlign: 'left',
          color: theme.color.b2,
          backgroundColor: theme.color.inverse.b1,
          width: '6.25rem',
          padding: '0.375rem',
          borderBottom: `0.063rem solid ${theme.color.b2}`,
          '&::before': {
            ...getControlBeforeStyles(theme, isBRRedesignEnabled),
            backgroundPositionX: '0.5rem',
            backgroundPositionY: '1rem',
          },
          '&:hover': {
            backgroundColor: theme.color.wh,
            animation: 'none !important',
            outline: 'none',
          },
          '&:focus': {
            animation: 'none !important',
            outline: 'none',
          },
        }
      : {}),
  });

export default getControlStyles;
